<template>
  <v-layout wrap>
    <v-flex xs12 v-if="embedded">
      <v-text-field
        box
        :label="fieldLabel"
        :disabled="readonly"
        v-model="value"
        hint="YES or NO"
        :error="validate()"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 style="max-width:190px !important" v-else>
      <v-text-field
        box
        :label="fieldLabel"
        :disabled="readonly"
        v-model="value"
        hint="YES or NO"
        :error="validate()"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from '@/helpers.js'

export default {
  name: 'boolean-field',
  props: {
    field: {
      type: Object
    },
    data: {
      type: Boolean
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    value: {
      get() {
        let val = false
        if (this.data !== undefined && this.data !== null) { val = this.data } else {
          if (this.field.default_value !== undefined) { val = this.field.default_value }
        }
        if (val) { return "Yes" } else { return "No" }
      },
      set(newValue) {
        const isYes = (newValue && newValue.toLowerCase() === "yes")
        this.$emit('update-item', { field: this.field.name, data: isYes, row: this.row })
        this.$emit("blurred", {
          field: this.field.name,
          data: isYes,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  },
  methods: {
    validate() {
      if (this.value === "" || this.value === null) {
        return false
      } else {
        if (this.value.toString().toLowerCase() === "yes" || this.value.toString().toLowerCase() === "no") {
          return false
        } else {
          return true
        }
      }
    }
  }
}
</script>
